import { useState } from "react";

import "../../assets/css/product.scss";
import Header from "../../components/header";
import Footer from "../../components/footer";

import ProductAuthModal from "../../components/modal/product_auth_modal";
import { useNavigate } from "react-router-dom";

function ProductStep1Component({ pathPrefix = "product" }) {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="product-list-container">
      <Header />
      <ul className="section1">
        <li>결제내역 조회하기</li>
        <li>
          결제완료 시 인증하신 휴대폰번호로 즉시 구독권이 발송됩니다.
          <br />
          구입하신 구독권은키즈다내 My &gt; 쿠폰등록 페이지에서 사용할 수
          있습니다.
          <br />
          만약 구독권을 전달받지 못하신 경우 SMS 인증을 통해 재발송할 수
          있습니다.
          <br />
          <a href="/application/service" target="_blank" rel="noreferrer">
            환불정책 바로가기
          </a>{" "}
          자세한 환불정책을 확인하실 수 있습니다.
        </li>
        <li>
          <button onClick={() => setIsModalOpen(true)}>조회하기</button>
        </li>
      </ul>
      <Footer />

      <ProductAuthModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSuccess={() => {
          setIsModalOpen(false);
          navigate(`/${pathPrefix}_step2`, { replace: true });
        }}
      />
    </div>
  );
}

export default ProductStep1Component;
